module.exports = __webpack_public_path__ + "img/2.2acec1f0.jpg";